module.exports = __webpack_public_path__ + "static/media/400061_02.b9b9d408.png";